import { cn } from "@design-system/Utilities";
import { type FC, type HTMLAttributes } from "react";
import { ReactComponent as TextLogo } from "../../../../assets/TextLogo.svg";

export const Logo: FC<HTMLAttributes<HTMLDivElement>> = ({ ...props }) => {
    return (
        <div
            className={cn("w-[120px] items-center", props.className)}
            {...props}
        >
            <TextLogo />
        </div>
    );
};
